export default __webpack_public_path__ + "static/media/Eselspinguin.f00a6f44.jpg";